export const currencies = [
	{ code: 'EUR', symbol: '€', decimalPrecision: 2 },
	{ code: 'ALL', symbol: 'Lek', decimalPrecision: 2 },
	{ code: 'BAM', symbol: 'KM', decimalPrecision: 2 },
	{ code: 'BRL', symbol: 'R$', decimalPrecision: 2 },
	{ code: 'GBP', symbol: '£', decimalPrecision: 2 },
	{ code: 'BGN', symbol: 'Лв.', decimalPrecision: 2 },
	{ code: 'XOF', symbol: 'CFA', decimalPrecision: 2 },
	{ code: 'CNY', symbol: '¥', decimalPrecision: 2 },
	{ code: 'CRC', symbol: '₡', decimalPrecision: 2 },
	{ code: 'HRK', symbol: 'kn', decimalPrecision: 2 },
	{ code: 'CZK', symbol: 'Kč', decimalPrecision: 2 },
	{ code: 'DKK', symbol: 'Kr.', decimalPrecision: 2 },
	{ code: 'GNF', symbol: 'FG', decimalPrecision: 2 },
	{ code: 'HUF', symbol: 'Ft', decimalPrecision: 2 },
	{ code: 'ISK', symbol: 'kr', decimalPrecision: 2 },
	{ code: 'ILS', symbol: '₪', decimalPrecision: 2 },
	{ code: 'JPY', symbol: '¥', decimalPrecision: 2 },
	{ code: 'MKD', symbol: 'ден', decimalPrecision: 2 },
	{ code: 'MGA', symbol: 'Ar', decimalPrecision: 2 },
	{ code: 'MUR', symbol: '₨', decimalPrecision: 2 },
	{ code: 'MXN', symbol: '$', decimalPrecision: 2 },
	{ code: 'MDL', symbol: 'L', decimalPrecision: 2 },
	{ code: 'NOK', symbol: 'kr', decimalPrecision: 2 },
	{ code: 'PLN', symbol: 'zł', decimalPrecision: 2 },
	{ code: 'RON', symbol: 'lei', decimalPrecision: 2 },
	{ code: 'RUB', symbol: '₽', decimalPrecision: 2 },
	{ code: 'RSD', symbol: 'din', decimalPrecision: 2 },
	{ code: 'SEK', symbol: 'kr', decimalPrecision: 2 },
	{ code: 'CHF', symbol: 'CHF', decimalPrecision: 2 },
	{ code: 'TND', symbol: 'ت.د', decimalPrecision: 2 },
	{ code: 'TRY', symbol: '₺', decimalPrecision: 2 },
	{ code: 'USD', symbol: '$', decimalPrecision: 2 },
	{ code: '', symbol: '', decimalPrecision: 2 },
];

export const getDecimalPrecision = (currencyToModify) => {
	const currency =
		currencies.find((cur) => cur.code === currencyToModify) || currencies.find((cur) => cur.code === 'EUR');
	return currency.decimalPrecision;
};

const hasDecimals = (currencyToModify) => {
	const currency = currencies.find((cur) => cur.code === currencyToModify);
	return currency ? currency.decimalPrecision > 0 : false;
};

export function amountToCents(number, currency = 'EUR') {
	const decimalPrecision = getDecimalPrecision(currency);

	number = number.replace(',', '.');

	const result = Number(number) * Math.pow(10, decimalPrecision);

	return Math.round(result);
}

export function formatAmount(number, currency) {
	const decimalLength = hasDecimals(currency);
	if (!decimalLength) return number;
	const integerPart = Math.floor(number / 100);
	const decimalPart = number % 100;
	let decimalPartString = '';
	if (decimalLength >= 0) {
		decimalPartString = '.' + (decimalPart < 10 ? '0' + decimalPart : decimalPart);
		if (decimalLength > 1) {
			decimalPartString += '0'.repeat(decimalLength - 1);
		}
	}
	return integerPart.toString() + decimalPartString;
}
